var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { FormControl, FormLabel, FormControlLabel, Grid, Radio, RadioGroup, Typography, useMediaQuery } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import { useTypedSelector } from "../state/store";
import * as quizAnswerActions from "../state/quizAnswer/actions";
import LaterQuizItemAddition from "./LaterQuizItemAddition";
import MarkdownText from "./MarkdownText";
var SmallCenteredGrid = styled(function (_a) {
  var matchesSmall = _a.matchesSmall,
      others = __rest(_a, ["matchesSmall"]);

  return React.createElement(Grid, __assign({}, others));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-align: ", ";\n  padding-bottom: ", ";\n"], ["\n  text-align: ", ";\n  padding-bottom: ", ";\n"])), function (_a) {
  var matchesSmall = _a.matchesSmall;
  return matchesSmall ? "center" : "inherit";
}, function (_a) {
  var matchesSmall = _a.matchesSmall;
  return matchesSmall ? ".5rem" : "0";
});
var WideGridItem = styled(function (_a) {
  var params = __rest(_a, []);

  return React.createElement(Grid, __assign({
    item: true,
    xs: 12
  }, params));
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var StyledRadio = styled(Radio)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding-left: 0.15rem;\n\n  MuiRadio-root {\n    color: #4f4f4f;\n  }\n"], ["\n  padding-left: 0.15rem;\n\n  MuiRadio-root {\n    color: #4f4f4f;\n  }\n"])));
var StyledFormLabel = styled(FormLabel)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  && {\n    color: black;\n  }\n"], ["\n  && {\n    color: black;\n  }\n"])));
var StyledOptionItem = styled(function (_a) {
  var numberOfOptions = _a.numberOfOptions,
      other = __rest(_a, ["numberOfOptions"]);

  return React.createElement(Grid, __assign({
    item: true,
    zeroMinWidth: true
  }, other));
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  maxwidth: ", ";\n"], ["\n  maxwidth: ", ";\n"])), function (_a) {
  var numberOfOptions = _a.numberOfOptions;
  return numberOfOptions <= 12 ? 100 / numberOfOptions + "%" : "100%";
});

var Scale = function Scale(_a) {
  var item = _a.item;
  var dispatch = useDispatch();

  var handleIntDataChange = function handleIntDataChange(e, value) {
    dispatch(quizAnswerActions.changeIntData(item.id, Number(value)));
  };

  var theme = useTheme();
  var matchesSmall = useMediaQuery(theme.breakpoints.down("xs"));
  var itemAnswers = useTypedSelector(function (state) {
    return state.quizAnswer.quizAnswer.itemAnswers;
  });
  var quizDisabled = useTypedSelector(function (state) {
    return state.quizAnswer.quizDisabled;
  });
  var itemAnswer = itemAnswers.find(function (ia) {
    return ia.quizItemId === item.id;
  });
  var intData = itemAnswer && itemAnswer.intData;

  if (!itemAnswer && !quizDisabled) {
    return React.createElement(LaterQuizItemAddition, {
      item: item
    });
  }

  return React.createElement(FormControl, {
    fullWidth: true
  }, React.createElement(Grid, {
    container: true,
    justify: "flex-start",
    alignItems: "center"
  }, React.createElement(SmallCenteredGrid, {
    matchesSmall: matchesSmall,
    item: true,
    xs: 12,
    sm: 5,
    md: 4
  }, React.createElement(StyledFormLabel, null, React.createElement(MarkdownText, {
    Component: Typography,
    variant: "body1"
  }, item.texts[0].title))), React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 7,
    md: 8
  }, React.createElement(ScaleOptions, {
    handleIntDataChange: handleIntDataChange,
    item: item,
    intData: typeof intData === "number" ? intData : undefined
  }))));
};

var ScaleOptions = function ScaleOptions(_a) {
  var handleIntDataChange = _a.handleIntDataChange,
      item = _a.item,
      intData = _a.intData;
  var number_of_options = 7;
  var userQuizState = useTypedSelector(function (state) {
    return state.user.userQuizState;
  });
  var quizDisabled = useTypedSelector(function (state) {
    return state.quizAnswer.quizDisabled;
  });
  var answerLocked = userQuizState && userQuizState.status === "locked";
  var minLabel = item.texts[0].minLabel;
  var maxLabel = item.texts[0].maxLabel;
  var theme = useTheme();

  if (item.minValue && item.maxValue) {
    number_of_options = item.maxValue - item.minValue + 1;
  }

  var alternatives = Array.from({
    length: number_of_options
  }, function (v, i) {
    return (item.minValue ? item.minValue : 1) + i;
  });
  return React.createElement(Grid, {
    container: true,
    direction: "column",
    alignContent: "center"
  }, (minLabel || maxLabel) && React.createElement(Grid, {
    item: true,
    xs: 12
  }, React.createElement(Grid, {
    container: true,
    justify: "space-between"
  }, React.createElement(Grid, {
    item: true
  }, minLabel || ""), React.createElement(Grid, {
    item: true
  }, maxLabel || ""))), React.createElement(WideGridItem, null, React.createElement(RadioGroup, {
    row: true,
    "aria-label": "agreement",
    name: "agreement",
    value: "" + intData,
    onChange: handleIntDataChange
  }, React.createElement(Grid, {
    container: true,
    justify: number_of_options <= 12 ? "space-between" : "flex-start"
  }, alternatives.map(function (number) {
    return React.createElement(StyledOptionItem, {
      key: number
    }, React.createElement(FormControlLabel, {
      value: "" + number,
      control: React.createElement(StyledRadio, {
        color: "primary",
        disabled: quizDisabled || answerLocked ? true : false,
        palette: theme.palette
      }),
      label: "" + number,
      labelPlacement: "start"
    }));
  })))));
};

export default Scale;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;